import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import useNotifications from '@/hooks/useNotification';

// Component to manage real-time notifications
export const NotificationManager: React.FC = () => {
  const { token } = useAuth();

  // Initialize notifications only when token is available
  useNotifications(token || '');

  return null; // This component doesn't render anything
};